import { useState } from "react";
import { Check, Copy, Terminal } from "lucide-react";
import { toast } from "sonner";

export const CommandBlock = ({ code, label = "PowerShell / CMD", testid = "command-block" }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Command copied to clipboard");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="rounded-xl border border-border/70 overflow-hidden bg-[#0a0e17]" data-testid={testid}>
      <div className="flex items-center justify-between px-4 py-2 border-b border-border/60 bg-secondary/40">
        <span className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-muted-foreground">
          <Terminal className="h-3.5 w-3.5 text-primary" /> {label}
        </span>
        <button
          onClick={copy}
          className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground hover:text-primary transition-colors"
          data-testid={`${testid}-copy`}
        >
          {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="p-4 text-sm font-mono text-sky-200 whitespace-pre-wrap leading-relaxed overflow-x-auto">
        {code}
      </pre>
    </div>
  );
};
